import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn, actionColumnCustomLableHelp, actionColumnCustomLableInfo } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P242List({ dataTable, setActionHeader, setActionDetail, setActionViewPic }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (rowData) => setActionDetail(rowData);
    const actionBodyViewPic = (rowData) => setActionViewPic(rowData);

    const headerLabel1 = <span className="hidden-responsive">กลับหน้าจอหลัก</span>;

    const header = (
        <div className="table-header">
            <Button className="p-button p-button-secondary btn-hidden-responsive " icon="pi pi-arrow-left" label={headerLabel1} onClick={() => setActionHeader("243")} />
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    header={header}
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="inspectDatetime" header="วัน-เวลาที่ตรวจ" sortable body={(e) => normalColumn(e, "inspectDatetime", "วัน-เวลาที่ตรวจ")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="requestNo" header="เลขที่ใบแจ้งฯ" body={(e) => normalColumn(e, "requestNo", "เลขที่ใบแจ้งฯ")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeNo" header="เส้นทาง" body={(e) => normalColumn(e, "routeNo", "เส้นทาง")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="commentText" header="ความเห็น" body={(e) => normalColumn(e, "commentText", "ความเห็น")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="foreman" header="หัวหน้างาน" body={(e) => normalColumn(e, "foreman", "หัวหน้างาน")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="supervisor" header="ผู้ควบคุม" body={(e) => normalColumn(e, "supervisor", "ผู้ควบคุม")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="รูปถ่าย" body={(e) => actionColumnCustomLableHelp(e, actionBodyViewPic, "รูปถ่าย", "fa fa-image")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="รายละเอียด" field="photoPath" body={(e) => actionColumnCustomLableInfo(e, actionBodyEdit, "รายละเอียด", "fa fa-search")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
